/* @flow */

import { rem } from 'polished';

import { boxShadow } from 'src/shared/app/base/style/token/elevation';
import { blueGrey, white } from '@e180/ui/lib/token/palette';
import { baseFontSize } from '@e180/ui/lib/token/typography';

export default {
  root: {
    backgroundColor: ({ accentColor }: Object) => accentColor,
    // @TODO - Handle other positions when needed
    borderTopLeftRadius: ({ position }) => (position === 'right' ? '8px' : 0),
    borderTopRightRadius: ({ position }) => (position === 'right' ? 0 : 0),
    borderBottomRightRadius: ({ position }) => (position === 'right' ? 0 : 0),
    borderBottomLeftRadius: ({ position }) =>
      position === 'right' ? '8px' : 0,
    textAlign: 'center',
    boxShadow,
    display: 'inline-block',
    overflow: 'hidden',
    fontSize: rem(12, baseFontSize),
    fontWeight: 600,
    color: blueGrey,
    '& >*': {
      color: blueGrey,
      stroke: blueGrey,
      display: 'block',
      textDecoration: 'none',
      padding: [rem(6, baseFontSize), rem(8, baseFontSize)],

      '&:visited': {
        color: blueGrey,
      },

      '&:hover': {
        backgroundColor: ({ darkAccentColor }: Object) => darkAccentColor,
        color: white,
        '& svg': {
          fill: white,
          stroke: white,
        },
      },
    },
  },
};
